import { NgModule ,CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CandidatesModule } from './candidates/candidates.module';
import { PanelMemberModule } from './panel-member/panel-member.module';
import { MaterialModule } from '../material/material.module';
import { ProcessesModule } from './processes/processes.module';
import { MainContentComponent } from './main-content.component';
import { StatusesModule } from './statuses/statuses.module';
import { LandingModule } from './landing/landing.module';



@NgModule({
  declarations: [
    MainContentComponent
  ],
  imports: [
    CommonModule,
    CandidatesModule,
    ProcessesModule,
    PanelMemberModule,
    StatusesModule,
    MaterialModule,
    LandingModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MainContentModule {}
